"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Clear_1 = require("@material-ui/icons/Clear");
var InputAdornment_1 = require("@material-ui/core/InputAdornment/InputAdornment");
var styles = {
    adornment: {
        color: '#ff0000',
        cursor: 'pointer',
        fontWeight: 'bolder'
    },
    svg: {
        width: 18,
        height: 18
    }
};
var RemoveValue = function (props) { return (React.createElement(InputAdornment_1.default, { style: styles.adornment, position: "end" },
    React.createElement("div", { "aria-label": "Remove the value", onClick: props.onClick },
        React.createElement(Clear_1.default, { style: styles.svg })))); };
exports.default = RemoveValue;
//# sourceMappingURL=RemoveValue.js.map